import { TOAST_TYPES, TOAST_DURATIONS } from '@/constants'

export default {
    methods: {
        showToast (message, type = TOAST_TYPES.SUCCESS, options = {}) {
            const defaultOptions = {
                type,
                duration:
                    TOAST_DURATIONS[type.toUpperCase()] ||
                    TOAST_DURATIONS.DEFAULT
            }

            this.$toasted.show(message, { ...defaultOptions, ...options })
        }
    }
}
